import { EuiButtonIcon, euiPaletteColorBlindBehindText } from "@elastic/eui";
import {
  ActionIcon,
  Button,
  Divider,
  Grid,
  Group,
  Input,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import React, { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
// import CreateView from "./CreateView";
// import DeleteView from "./DeleteView";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconEye, IconSearch, IconTimeDuration15 } from "@tabler/icons-react";
import dayjs from "dayjs";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { useLocation, useNavigate } from "react-router-dom";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { TblCollectionForm } from "../../../model/TblCollectionForm";
import DeleteView from "./DeleteView";
import EditView from "./EditView";
const visColorsBehindText = euiPaletteColorBlindBehindText();

const optionSearch = {
  isActive: [
    {
      value: true,
      label: "Kích hoạt",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: false,
      label: "Chưa kích hoạt",
      color: visColorsBehindText[1],
    },
  ],

  status: [
    {
      value: "S",
      label: "Thành công",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: "C",
      label: "Huỷ bỏ",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
    {
      value: "P",
      label: "Chờ xử lý",
      "data-test-subj": "titanOption",
      color: visColorsBehindText[0],
    },
  ],
};

const CollectionForm = () => {
  // const columns: Array<EuiBasicTableColumn<any>> = [
  //   {
  //     field: "id",
  //     name: "ID",
  //     sortable: true,
  //     truncateText: true,
  //     width: "3%",
  //   },
  //   {
  //     field: "",
  //     name: "Khách hàng",
  //     sortable: true,
  //     width: "22%",
  //     truncateText: true,
  //     render: (online: TblCollectionForm) => (
  //       <p>
  //         {online.fullname} ({online.email})
  //       </p>
  //     ),
  //   },
  //   {
  //     field: "productName",
  //     name: "Sản phẩm",
  //     sortable: true,
  //     truncateText: true,
  //     render: (productName: string, collection: TblCollectionForm) => (
  //       <EuiLink
  //         target="_blank"
  //         onClick={(e: any) => {
  //           handleEditData(collection.id);
  //         }}
  //       >
  //         {productName}
  //       </EuiLink>
  //     ),
  //   },
  //   {
  //     field: "creationDate",
  //     name: "Thời gian",
  //     sortable: true,
  //     truncateText: true,
  //     width: "10%",
  //     render: (date: string) => (
  //       <Text w={"100%"} truncate>
  //         {date}
  //       </Text>
  //     ),
  //   },
  //   {
  //     name: "Actions",
  //     width: "5%",
  //     render: (online: TblCollectionForm) => {
  //       return (
  //         <>
  //           <EuiFlexGroup
  //             responsive={true}
  //             wrap={false}
  //             gutterSize="s"
  //             alignItems="center"
  //           >
  //             <EuiFlexItem grow={false}>
  //               <EuiButtonIcon
  //                 iconType="documentEdit"
  //                 aria-label="Dashboard"
  //                 color="success"
  //                 onClick={(e: any) => {
  //                   if (isNullOrUndefined(online))
  //                     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //                   else {
  //                     editItem(online.id);
  //                   }
  //                 }}
  //               />
  //             </EuiFlexItem>
  //             <EuiFlexItem grow={false}>
  //               <EuiButtonIcon
  //                 iconType="trash"
  //                 color="danger"
  //                 onClick={(e: any) => {
  //                   if (isNullOrUndefined(online))
  //                     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //                   else {
  //                     deleteItem([online.id]);
  //                   }
  //                 }}
  //               />
  //             </EuiFlexItem>
  //           </EuiFlexGroup>
  //         </>
  //       );
  //     },
  //   },
  // ];
  // Cập nhật đường dẫn này
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [datas, setDatas] = useState<TblCollectionForm[]>([]);
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 50,
      },
      {
        accessorKey: "fullname",
        header: "Tên khách hàng",
        Cell: ({ row }) => (
          <>
            {row.original.fullname} ({row.original.email})
          </>
        ),
        size: 300,
      },
      {
        accessorKey: "mobile",
        header: "Số điện thoại",
      },
      {
        accessorKey: "productName",
        header: "Sản phẩm",
        Cell: ({ cell, row }) => (
          <Text
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word",
              lineHeight: "1.4",
              maxWidth: "380px",
              padding: "4px 0",
            }}
          >
            {cell.getValue<string>()}
          </Text>
        ),
        size: 400,
      },
      {
        accessorKey: "creationDate",
        header: "Thời gian",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        size: 120,
      },
      {
        id: "actions",
        header: "Thao tác",
        Cell: ({ row }) => {
          const online = row.original;
          return (
            <Group justify="center" gap="xs">
              <Tooltip label="Xem chi tiết">
                <ActionIcon
                  variant="subtle"
                  aria-label="Edit"
                  onClick={() => {
                    if (!online) {
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    } else {
                      editItem(online.id);
                    }
                  }}
                >
                  <IconEye size={16} />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Xoá">
                <ActionIcon
                  variant="subtle"
                  aria-label="Delete"
                  onClick={() => {
                    if (!online) {
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    } else {
                      deleteItem([online.id]);
                    }
                  }}
                >
                  <EuiButtonIcon iconType="trash" color="danger" />
                </ActionIcon>
              </Tooltip>
            </Group>
          );
        },
        size: 100,
        enableSorting: false,
        enableColumnActions: false,
      },
    ],
    [datas, deleteViewStatus]
  );

  // const getStatusColor = (status: any) => {
  //   switch (status) {
  //     case "I":
  //       return "red";
  //     case "A":
  //       return "green";
  //     default:
  //       return "subdued";
  //   }
  // };
  type SearchCriteria = {
    keySearch?: string;
    Phone?: number;
    FromDate?: string;
    ToDate?: string;
  };
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      Phone: _searchJson && checkedPinSearch ? _searchJson?.Phone : "",
      FromDate: _searchJson && checkedPinSearch ? _searchJson?.FromDate : "",
      ToDate: _searchJson && checkedPinSearch ? _searchJson?.ToDate : "",
    },
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [selectedOptions, setSelected] = useState();
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [selectedSearch, setSelectedSearch] = useState<{
    isActive: any[];
    status: any[];
  }>({
    isActive: [],
    status: [],
  });
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  // const [selectIds, setSelectedItems] = useState<any[]>([]);

  const [total, setTotal] = useState(0);

  const handleEditData = async (id: number) => {
    if (id) {
      editItem(id);
    } else {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    }
  };

  // const onTableChange = async ({
  //   page: { index, size },
  // }: CriteriaWithPagination<any>) => {
  //   setPagination({
  //     ...pagination,
  //     pageIndex: index,
  //     pageSize: size,
  //     totalItemCount: 1000,
  //   });
  // };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  const handleChangeSearch = (value: any[], key: string) => {
    setSelectedSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  // const onSelectionChange = (selectedItems: any[]) => {
  //   setSelectedItems(selectedItems);
  // };
  // const selection: EuiTableSelectionType<any> = {
  //   selectable: (user: any) => true,
  //   selectableMessage: (selectable: boolean) =>
  //     !selectable ? "User is currently offline" : "",
  //   onSelectionChange,
  // };

  // const openModal = () =>
  //   modals.openConfirmModal({
  //     title: (
  //       <>
  //         <div color="white">
  //           <Title order={5}>Thêm mới đơn</Title>
  //         </div>
  //       </>
  //     ),
  //     children: (
  //       <CreateView
  //         onSearch={() =>
  //           fetchDataCollectionForm(
  //             pagination.pageIndex,
  //             pagination.pageSize,
  //             paramSearch?.keyWord,
  //             paramSearch?.inActive
  //           )
  //         }
  //       />
  //     ),
  //     confirmProps: { display: "none" },
  //     cancelProps: { display: "none" },
  //   });

  const openModalEdit = () => {
    if (selectIds && (selectIds.length < 1 || selectIds.length > 1))
      NotificationExtension.Warn("Xin vui lòng chọn 1 đơn để chỉnh sửa !");
    else {
      editItem(selectIds[0].id);
    }
  };

  const openModalDelete = () => {
    if (selectIds && selectIds.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      deleteItem(selectIds);
    }
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa đơn</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() => fetchDataCollectionForm()}
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xem chi tiết đơn!</Title>
        </>
      ),
      children: <EditView id={id} onSearch={() => fetchDataCollectionForm()} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  // const elementSearch = [
  //   <Menu.Item closeMenuOnClick={false}>
  //     <EuiFormRow label="Chọn tình trạng ">
  //       <EuiComboBox
  //         aria-label="Accessible screen reader label"
  //         placeholder="Chọn..."
  //         options={optionSearch.status}
  //         selectedOptions={selectedSearch?.status}
  //         onChange={(e) => handleChangeSearch(e, "status")}
  //         fullWidth={true}
  //         singleSelection={{ asPlainText: true }}
  //         isDisabled={loading}
  //         isCaseSensitive
  //       />
  //     </EuiFormRow>
  //   </Menu.Item>,
  //   <Menu.Item closeMenuOnClick={false}>
  //     <EuiFormRow label="Trạng thái ">
  //       <EuiComboBox
  //         aria-label="Accessible screen reader label"
  //         placeholder="Chọn..."
  //         options={optionSearch.isActive}
  //         selectedOptions={selectedSearch?.isActive}
  //         onChange={(e) => handleChangeSearch(e, "isActive")}
  //         fullWidth={true}
  //         isDisabled={loading}
  //         singleSelection={{ asPlainText: true }}
  //         isCaseSensitive
  //       />
  //     </EuiFormRow>
  //   </Menu.Item>,
  // ];

  const fetchDataCollectionForm = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL2);

    try {
      const search = form.getValues();
      let urlSearch = `${API_ROUTE.GET_LIST_COLLECTION_FORM}?Skip=${pagination?.pageIndex}&Take=${pagination?.pageSize}`;
      if (search.keySearch) {
        urlSearch += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.Phone) {
        urlSearch += `&Phone=${search.Phone}`;
      }
      if (search.FromDate) {
        urlSearch += `&FromDate=${search.FromDate}`;
      }
      if (search.ToDate) {
        urlSearch += `&ToDate=${search.ToDate}`;
      }

      let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        setTotal(0);
        // setDatas([]);
      } else {
        setDatas(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(form.getValues())
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataCollectionForm();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  const table = useMantineReactTable({
    columns,
    data: datas,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "userName"],
        right: ["actions"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  return (
    <>
      <BreadCrumb />
      <Divider my="sm" />
      {/* <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={() =>
          fetchDataCollectionForm(
            pagination.pageIndex,
            pagination.pageSize,
            paramSearch?.keyWord,
            paramSearch?.inActive
          )
        }
        elementSearch={elementSearch}
      /> */}
      {/* <EuiSpacer size="l" />
       */}
      <Grid justify="space-between" align="center" mb={10}>
        <Grid.Col span="auto">
          <Group gap="sm">
            <Input
              placeholder="Nhập tìm kiếm"
              key={form.key("keySearch")}
              type="text"
              leftSection={<IconSearch size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataCollectionForm();
                }
              }}
              {...form.getInputProps("keySearch")}
              w={200}
            />
            <Input
              placeholder="Nhập số điện thoại"
              key={form.key("Phone")}
              type="text"
              leftSection={<IconSearch size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataCollectionForm();
                }
              }}
              {...form.getInputProps("Phone")}
              w={200}
            />
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              key={form.key("FromDate")}
              {...form.getInputProps("FromDate")}
              value={
                form.getValues().FromDate
                  ? dayjs(form.getValues().FromDate).toDate()
                  : null
              }
              onChange={(date) =>
                form.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              w={200}
              clearable
            />
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              key={form.key("ToDate")}
              {...form.getInputProps("ToDate")}
              value={
                form.getValues().ToDate
                  ? dayjs(form.getValues().ToDate).toDate()
                  : null
              }
              onChange={(date) =>
                form.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              w={200}
              clearable
            />
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchDataCollectionForm();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>

        <Grid.Col span="content">
          <Group justify="flex-end">
            <AppAction
              openModalDelete={openModalDelete}
              // openModalEdit={openModalEdit}
            />
          </Group>
        </Grid.Col>
      </Grid>
      {/* <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={datas ? datas : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={"Không có dữ liệu"}
        selection={selection}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      /> */}
      <MantineReactTable table={table} />
    </>
  );
};

export default CollectionForm;
